module.exports = __webpack_public_path__ + "media/images/share/logo-8fb26f275e6757500c78649ee0de6fed.png";